/* eslint-disable promise/prefer-await-to-callbacks */
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import ThemeContext from '../../providers/ThemeProvider';
import Icon from '../Icon';

const FacetedNavToggle = ({ buttonText, isExpander, eventKey, callback }) => {
  const theme = useContext(ThemeContext);
  const currentEventKey = useContext(AccordionContext);
  const isCurrentEventKey = currentEventKey === eventKey;
  const stateIcon = isCurrentEventKey ? faAngleUp : faAngleDown;
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey),
  );
  const iconColor = theme.colors.primaryonwhite;

  return (
    <>
      <button
        className="head-section__button"
        onClick={decoratedOnClick}
        type="button"
      >
        <div className="head-section">
          <span className="head-section__button-text">{buttonText}</span>
          {isExpander && (
            <span className="head-section__state-icon">
              <Icon color={iconColor} faIcon={stateIcon} />
            </span>
          )}
        </div>
      </button>
      <style jsx>{`
        .head-section {
          background-color: ${theme.colors.mobilemenubg};
          padding: 9px 8px;
          line-height: 16px;
          position: relative;
        }
        .head-section__button {
          border: 0;
          text-align: left;
          margin: 0;
          padding: 0;
          width: 100%;
        }
        .head-section__button-text {
          color: ${theme.colors.primaryonwhite};
          font-size: 13px;
          font-weight: bold;
          line-height: 13px;
        }
        .head-section__state-icon {
          color: ${theme.colors.primaryonwhite};
          position: absolute;
          right: 8px;
        }
      `}</style>
    </>
  );
};

export default FacetedNavToggle;

FacetedNavToggle.propTypes = {
  buttonText: PropTypes.string.isRequired,
  callback: PropTypes.func,
  eventKey: PropTypes.string,
  isExpander: PropTypes.bool,
};
